<template>
  <aside class="d-none d-md-block bg-gray-100 rounded font-condensed position-relative overflow-hidden pb-lg-4">
    <overlay-wrapper
      :show="loading"
      class="h-100"
    >
      <BNav
        vertical
        class="inpage-nav d-none d-lg-flex"
        data-test-id="inpage-nav-desktop"
        :class="{ 'py-5' : loading && !items.length }"
      >
        <li
          v-for="(item, i) in items"
          :key="'page_navigation_item_' + i"
          class="nav-item text-nowrap"
          :class="{'disabled':item.disabled}"
        >
          <router-link
            v-if="!item.link"
            class="nav-link text-wrap"
            :to="{ path: item.path, query: { serial: getCurrentSerial, [constants.REGION_QUERY_NAME]: getRegion } }"
            :data-test-id="'nav-page-vertical-item_' + i"
            @click="onNavLinkClick($event, item.disabled)"
          >
            <b-icon
              v-if="item.icon && item.icon !== 'null'"
              key="icon"
              :icon="item.icon"
              class="me-2"
              fixed-width
            />
            <b-icon
              v-else-if="hasIcons"
              key="default-icon"
              :icon="'cog'"
              class="invisible me-2"
              fixed-width
            />
            {{ translate(item.title.ck, labels, item.title.cp) }}
          </router-link>
          <a
            v-if="item.link"
            :href="getHrefLink(item)"
            target="_blank"
            class="nav-link text-wrap d-flex"
            :data-test-id="'nav-page-vertical-item_' + i"
          >
            <b-icon
              v-if="item.icon && item.icon !== 'null'"
              key="icon"
              :icon="item.icon"
              class="nav-link-direct-icon"
              fixed-width
            />
            <b-icon
              v-else-if="hasIcons"
              key="default-icon"
              :icon="'cog'"
              class="invisible nav-link-direct-icon"
              fixed-width
            />
            {{ translate(item.title.ck, labels, item.title.cp) }}
            <b-icon
              class="text-small ms-2"
              icon="bobcaticon-create"
            />
          </a>
        </li>
      </BNav>
      <div
        v-if="disabled"
        class="mask disabled"
      />
    </overlay-wrapper>
  </aside>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import {useStore} from 'vuex'
import constants from '@/constants'
import {useCommon} from '@/composables/useCommon'

const props = withDefaults(defineProps<{
  disabled?: boolean
  loading?: boolean
  items: any[]
}>(), {
  disabled: false,
  loading: true
})

const store = useStore()
const {labels, translate, translatedLabel} = useCommon()

const getRegion = computed(() => store.getters['mymachine/getRegion'])
const getCurrentSerial = computed(() => store.getters['mymachine/getCurrentSerial'])
const hasIcons = computed(() => props.items.filter((x: any) => x.icon && x.icon !== 'null').length)

function getHrefLink(item: any): string {
  const link = translatedLabel(item.link.ck, item.link.cp)
  if (link.includes('http')) return link
  return '#'
}

function onNavLinkClick(event: Event, disabled?: boolean): void {
  if (!disabled) return
  event.preventDefault()
  event.stopPropagation()
}
</script>

<style lang="scss">
@import '../../scss/transitions';
@import '../../scss/colors';

.inpage-nav {
  .nav-item {
    &:hover:not(.disabled) {
      box-shadow: 0 .5rem 1rem rgba($black, .15);
      background: $white;
      transition: $transition-base;
      z-index: 1;
    }

    &.disabled {
      .nav-link {
        cursor: default;
        color: $gray-500;
        pointer-events: none;
      }
    }
  }
  .nav-link {
    padding: 1.1rem 1.5rem;
    color: $black;
    font-size: 1.125rem;
    transition: $transition-base;

    &:hover,
    &:focus {
      color: $black;
    }

    &-direct-icon {
      margin-right: 0.8rem;
    }

    &.router-link-exact-active {
      color: $primary;
      background: $white;
    }
  }
}
</style>
